import axios from "axios";
import { API_URL, getHeaderWithAuthorization } from "./API";

export type PaymentPlatform = "web" | "mobile";

export interface PaymentLinkResponse {
	link: string;
	id: string;
}

export interface TrialStatus {
	days_remaining_for_trial: number;
	is_payed: boolean;
}

/**
 * Создание ссылки для оплаты доступа
 * POST /v2/billing/payments/link
 */
export const createPaymentLink = async (
	platform: PaymentPlatform = "web"
): Promise<PaymentLinkResponse> => {
	const response = await axios.post(
		`${API_URL}v2/billing/payments/link`,
		{ platform },
		{ headers: getHeaderWithAuthorization() }
	);
	return response.data;
};

/**
 * Открытие страницы оплаты
 */
export const openPaymentPage = async (
	platform: PaymentPlatform = "web"
): Promise<void> => {
	const { link } = await createPaymentLink(platform);
	window.open(link, "_blank");
};

